/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import { RestResponse, FieldSet, FieldSetField } from '../model';
import { ApiHeaders } from './headers';

@Injectable()
export class FieldSetProvider {

  constructor(
    private http: HttpClient
  ) {}

  /**
   * This method will return object WITHOUT TemplateFields
   * */
  getFieldSets(): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/fieldset`, ApiHeaders.getOptions());
  }

  /**
   * This method will return full object with TemplateFields
   * */
  getFieldSet(id: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/fieldset/${id}`, ApiHeaders.getOptions());
  }

  /**
   * This method doesn't save included TemplateFields
   * */
  saveFieldSet(fieldSet: FieldSet): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/fieldset`, fieldSet, ApiHeaders.getOptions());
  }

  deleteFieldSet(id: string): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/fieldset/${id}`, ApiHeaders.getOptions());
  }

  saveFieldSetField(fieldSetId: string, field: FieldSetField): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/fieldset/${fieldSetId}/field`, field, ApiHeaders.getOptions());
  }

  deleteFieldSetField(fieldSetId: string, fieldId: string): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/fieldset/${fieldSetId}/field/${fieldId}`, ApiHeaders.getOptions());
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/fieldset/${id}/name`, {
        FIELD: field,
        VALUE: value
      }, ApiHeaders.getOptions());
  }
}
